module.exports = __webpack_public_path__ + "img/trunk_9x4_z16.21d03a45.svg";